import { getI18n } from "react-i18next";
import { GarageKeyType } from "src/components/UserAccount/shared/GarageKey";
import { ValidationResult } from "src/types/ValidationResult";

export interface GarageUnlockAccess {
    garageKey: string;
    garageKeyType: GarageKeyType;
    [key: string]: any;
}

export const validateUnlockCode = (code: string): ValidationResult => {
    const i18n = getI18n();

    if (!code || code.length < 5) {
        return {
            errorMessage: i18n.t("UserAccount.UnlockGarage.requiredErrorMessage"),
            isValid: false,
        };
    }

    return {
        errorMessage: "",
        isValid: true,
    };
};
